var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg02Line(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 945,
    viewBox: "0 0 1920 945",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_122_361)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1926.87 9.14177C1927.35 10.7294 1926.45 12.4006 1924.86 12.8747L1732.15 70.4104L1732.06 70.4394L1654.68 96.268C1654.41 96.3597 1654.18 96.5662 1654.07 96.834L1622.81 172.347C1622.65 172.72 1622.29 172.964 1621.88 172.964H1542.88C1542.45 172.964 1542.07 173.239 1541.93 173.647L1512.36 262.15C1512.24 262.496 1511.95 262.752 1511.59 262.817L1335.88 294.607C1335.56 294.665 1335.29 294.875 1335.15 295.169L1248.41 481.151C1248.25 481.485 1247.93 481.706 1247.56 481.727L1092.65 490.617C1092.39 490.633 1092.14 490.756 1091.96 490.959L888.051 725.004C887.992 725.072 887.923 725.132 887.848 725.182L776.637 798.548C776.529 798.619 776.409 798.669 776.282 798.694L571.115 839.72L387.646 883.096L-3.0678 1010.85C-4.64261 1011.37 -6.33667 1010.51 -6.8516 1008.93C-7.36653 1007.36 -6.50733 1005.66 -4.93253 1005.15L386.02 877.315L569.837 833.857L773.956 793.04C774.083 793.015 774.203 792.965 774.311 792.894L883.861 720.624C883.937 720.574 884.005 720.514 884.064 720.446L1089.09 485.113C1089.27 484.91 1089.52 484.787 1089.79 484.772L1243.64 475.942C1244 475.921 1244.33 475.7 1244.48 475.367L1331.03 289.818C1331.16 289.523 1331.43 289.314 1331.75 289.256L1507.02 257.545C1507.38 257.48 1507.68 257.224 1507.79 256.878L1537.61 167.647C1537.75 167.239 1538.13 166.964 1538.56 166.964H1617.87C1618.28 166.964 1618.64 166.72 1618.8 166.347L1649.58 92.0093C1649.69 91.7415 1649.91 91.535 1650.18 91.4433L1730.3 64.7039L1923.14 7.12545C1924.73 6.65143 1926.4 7.55417 1926.87 9.14177Z",
    fill: "url(#paint0_linear_122_361)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M776.87 801.636L776.871 801.635C777.376 801.534 777.858 801.337 778.289 801.052L889.5 727.686C889.802 727.486 890.076 727.247 890.313 726.974L1093.67 493.564L1247.73 484.722C1249.2 484.638 1250.5 483.753 1251.13 482.419L1337.43 297.375L1512.12 265.769C1513.56 265.509 1514.74 264.486 1515.2 263.101L1512.38 262.158L1515.2 263.1L1544.32 175.964H1621.88C1623.5 175.964 1624.96 174.989 1625.58 173.494L1656.5 98.8247L1732.96 73.3L1733.01 73.285L1733.06 73.2711L1925.72 15.7493C1928.89 14.8012 1930.7 11.4587 1929.75 8.28351C1928.8 5.10825 1925.46 3.30283 1922.28 4.25084L1729.44 61.8293C1729.41 61.8384 1729.38 61.8481 1729.35 61.8582L1649.23 88.5976C1648.14 88.9646 1647.25 89.7906 1646.81 90.8615L1616.54 163.964H1538.56C1536.84 163.964 1535.31 165.064 1534.77 166.696L1505.32 254.804L1331.22 286.304C1329.94 286.536 1328.86 287.373 1328.31 288.549L1331.03 289.818L1328.31 288.55L1242.27 473.016L1089.62 481.777C1088.54 481.838 1087.54 482.331 1086.83 483.143L881.981 718.27L772.985 790.175L569.249 830.915C569.215 830.922 569.181 830.929 569.147 830.937L385.33 874.396C385.276 874.408 385.222 874.422 385.169 874.438C385.142 874.446 385.115 874.455 385.087 874.464L-5.86489 1002.3C-9.01448 1003.33 -10.7329 1006.72 -9.70305 1009.86C-8.67319 1013.01 -5.2851 1014.73 -2.13544 1013.7L388.458 885.987L571.754 842.652L776.87 801.636ZM1092.83 493.612L1092.84 493.612C1092.83 493.612 1092.83 493.612 1092.83 493.612ZM1656.85 97.9814C1656.84 97.9846 1656.84 97.9877 1656.84 97.9908L1656.85 97.9817L1655 97.2165L1656.85 97.9814ZM1616.02 165.199C1616.03 165.197 1616.03 165.194 1616.03 165.192L1616.02 165.199L1617.87 165.964L1616.02 165.199Z",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_122_361",
    x: -13.0027,
    y: 0.997803,
    width: 1946,
    height: 1016,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_122_361"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_122_361",
    x1: 2139,
    y1: -778.5,
    x2: -75.5002,
    y2: 1071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#076AEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369792,
    stopColor: "#4C9AFF",
    stopOpacity: 0.630208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C9AFF",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg02Line);
export default __webpack_public_path__ + "static/media/bg_02_line.0dcb0ea89c0576d12410fb7de8893c1c.svg";
export { ForwardRef as ReactComponent };